// react
import { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import axios, { AxiosResponse } from "axios";
// mui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Autocomplete,
  TextField,
  useTheme,
  styled,
} from "@mui/material";
// src
import { config } from "../../../config/config";
import FormatUtil from "../../Utility/ProjectComUtil";
import {
  coordinateSystem as coordinateSystemData,
  verticalShift,
} from "../../../config/SelectListData";
import {
  IEnabledUpdateProjectDetail,
  PollingContext,
  ProcessIds,
  ProjectDetailContext,
  UseSnackbarContext,
} from "../Interfaces/ProjectDetailInterfaces";
import { LoadingButton } from "@mui/lab";
import { Common } from "../../../../common/src";
import CoordinateContext from "../Contexts/CoordinateContext";

type Props = {
  // storageData: Data[];
  // setStorageData: React.Dispatch<React.SetStateAction<Data[]>>;
  // localizedStorageData: Data[];
  // setLocalizedStorageData: React.Dispatch<React.SetStateAction<Data[]>>;
  // dashboardData: any;
  // setDashboardData: React.Dispatch<React.SetStateAction<any>>;
  // showFlag: boolean;
  // setShowFlag: React.Dispatch<React.SetStateAction<boolean>>;
  // currentType: EDataType;
  open: boolean;
  close: () => void;
};

type Data = {
  id: string;
  left: string;
  right?: string | boolean;
};

enum EDataType {
  EPSG = "EPSG",
  LOCALIZE = "LOCALIZE",
  NONE = "NONE",
}

const CoordinateSystemDialog = (coordProps: Props) => {
  const { openSuccess, openError } = useContext(UseSnackbarContext);
  const { projectDetail, getProjectDetail, updateProjectDetail } =
    useContext(ProjectDetailContext);
  const {
    fetchCS,
    localizedStorageData,
    storageData,
    currentType,
    setStorageData,
    setLocalizedStorageData,
    dashboardData,
    fetchDashboardCS,
  } = useContext(CoordinateContext);

  const { processIds, updateProcessIds } = useContext(PollingContext);

  const { t } = useTranslation();
  const pollingIdRef = useRef(null);

  /*****************************************
    state
  ******************************************/
  const [step, setStep] = useState<number>(1);
  // 0: dashboard, 1: select
  const [coordinateRadio, setCoordinateRadio] = useState<number>(null);
  // const [currentType, setCurrentType] = useState<EDataType>(EDataType.NONE);
  const [displayText, setDisplayText] = useState<boolean>(false);
  const [whileTransform, setWhileTransform] = useState<boolean>(false);

  // 座標変換実施フラグ
  let transformFlags: boolean = true;

  // 変換先指定
  const [selectedDestData, setSelectedData] = useState<any[]>([
    { id: "horizontal", value: "", label: "" },
    { id: "vertical", value: "", label: "" },
  ]);

  // 表示用: ステレオなし
  const [destData, setDestData] = useState<Data[]>([
    { id: "horizontal", left: t("COORDINATE_SYSTEM"), right: "" },
    { id: "vertical", left: t("VERTICAL_COORDINATE_SYSTEM"), right: "" },
  ]);

  // 表示用: ステレオあり
  const [LocalizedDestData, setLocalizedDestData] = useState<Data[]>([
    { id: "rotation", left: t("ROTATION"), right: "" },
    { id: "originEasting", left: t("ORIGIN_EASTING"), right: "" },
    { id: "originNorthing", left: t("ORIGIN_NORTHING"), right: "" },
    { id: "originLatitude", left: t("ORIGIN_LATITUDE"), right: "" },
    { id: "originLongitude", left: t("ORIGIN_LONGITUDE"), right: "" },
    { id: "scaleFactor", left: t("SCALE_FACTOR"), right: "" },
    { id: "verticalOffset", left: t("VERTICAL_OFFSET"), right: "" },
    { id: "inclineX", left: t("INCLINE_X"), right: "" },
    { id: "inclineY", left: t("INCLINE_Y"), right: "" },
  ]);

  const [disabledNext1, setDisabledNext1] = useState<any>(true);
  const [loadingNext1, setLoadingNext1] = useState<any>(true);
  const [disableNextStep, setDisableNextStep] = useState<any>(true);

  // const fetchCS = () => {
  //   axios
  //     .get(
  //       `${config.serverHost}/api/v1/project/${projectDetail?.id}/coordinate-system`,
  //       { withCredentials: true }
  //     )
  //     .then((res: AxiosResponse<Common.ProjectViDoc>) => {
  //       setDisplayText(true);
  //       if (res.data.horizontal) {
  //         setCurrentType(EDataType.EPSG);
  //       } else if (res.data.originEasting) {
  //         setCurrentType(EDataType.LOCALIZE);
  //       } else {
  //         setCurrentType(EDataType.NONE);
  //         res.data.conditionFlag = false;
  //       }
  //       if (res.data.conditionFlag) {
  //         const newVidocData = coordProps.localizedStorageData.map((item) => {
  //           item.right = res.data[item.id as keyof Common.ProjectViDoc];
  //           return item;
  //         });
  //         coordProps.setLocalizedStorageData(newVidocData);
  //       } else {
  //         const newlocalizeData = coordProps.storageData.map((item) => {
  //           item.right = (
  //             item.id === "horizontal" ? coordinateSystemData : verticalShift
  //           ).find(
  //             (x) => x.value === res.data[item.id as keyof Common.ProjectViDoc]
  //           )?.label;
  //           return item;
  //         });
  //         coordProps.setStorageData(newlocalizeData);
  //       }
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //     });
  // };

  // const fetchDashboardCS = async () => {
  //   return await axios
  //     .get(
  //       `${config.serverHost}/api/v1/project/${projectDetail?.id}/coordinate-system/dashboard`,
  //       { withCredentials: true }
  //     )
  //     .then((res: AxiosResponse<any>) => {
  //       // ステレオパラメータの場合 TRUE
  //       if (res.data.conditionFlag) coordProps.setShowFlag(true);
  //       coordProps.setDashboardData(res.data);
  //       return res.data;
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //       return undefined;
  //     });
  // };

  useEffect(() => {
    let disable = true;
    if (coordinateRadio !== 0 || !dashboardData?.conditionFlag) {
      destData.forEach((item) => {
        if (item.right) {
          disable = false;
        }
      });
    } else {
      LocalizedDestData.forEach((item) => {
        if (item.right) {
          disable = false;
        }
      });
    }
    setDisableNextStep(disable);
  }, [destData, step]);

  useEffect(() => {
    setDisabledNext1(
      coordinateRadio === null ||
        (coordinateRadio === 1 && selectedDestData.some((v) => v.value === ""))
    );
  }, [coordinateRadio, selectedDestData]);

  useEffect(() => {
    setLoadingNext1(coordinateRadio === 0 && !dashboardData);
  }, [coordinateRadio, dashboardData]);

  const handleNextStep = () => {
    if (step === 1) {
      // 選択状況をチェック
      handlerSetCoordinateSystem();
      // [transformFlags = false]の場合は次の画面に遷移しない。
      if (!transformFlags) {
        transformFlags = true;
        return;
      }
    }

    if (step < 2) {
      setWhileTransform(false);
      setStep((val) => val + 1);
    } else {
      if (destData.find((x) => x.id === "horizontal")?.right) {
        // EPSGの座標変換
        const data: any = {};
        destData.forEach((x) => {
          data[x.id] = (
            x.id === "horizontal" ? coordinateSystemData : verticalShift
          ).find((item) => item.label === x.right)?.value;
        });
        coordinateTransformation(data);
      } else {
        // ステレオパラメータ変換
        coordinateTransformation(dashboardData);
      }
    }
  };

  const statusErrMsg = (resStatus: Common.ProcessingStatus) => {
    // const PROCESSING = Common.PROJECT_STATUS_ENUM.PROCESSING;
    if (resStatus.helmert_transformation) {
      openError(t("HELMERT_TRANSFORM") + t("PROCESSING_STATUS_ERROR"));
    } else if (resStatus.coordinate_transformation) {
      openError(t("COORDINATE_PROCESS") + t("PROCESSING_STATUS_ERROR"));
    } else if (resStatus.point_splitting) {
      openError(t("POINT_GROUP_SEGMENTATION") + t("PROCESSING_STATUS_ERROR"));
    } else if (resStatus.remove) {
      openError(t("SIMPLE_POINT_REMOVAL") + t("PROCESSING_STATUS_ERROR"));
    } else if (resStatus.txt_conversion) {
      openError(t("TEXT_CONVERSION") + t("PROCESSING_STATUS_ERROR"));
    }
  };

  // 座標系変換を実施
  const coordinateTransformation = (data: any) => {
    setWhileTransform(true);
    axios
      .put(
        `${config.serverHost}/api/v1/project/${projectDetail?.id}/coordinate-system`,
        data,
        { withCredentials: true }
      )
      .then((res: AxiosResponse<any>) => {
        openSuccess(t("START_COORDINATE_PROCESS"));
        fetchCS(projectDetail?.id);
        fetchDashboardCS(projectDetail?.id);

        updateProcessIds({
          sfm: res.data.process_id,
          helmert: processIds.helmert,
        } as ProcessIds);
      })
      .catch((err) => {
        switch (err.response.status) {
          case 504:
            break;
          case 409:
            openError(t("COULD_NOT_SAVE"));
            break;
          case 429:
            statusErrMsg(err.response.data);
            break;
          default:
            openError(t("ERROR"));
            break;
        }
      })
      .finally(() => {
        getProjectDetail(false);
        setWhileTransform(false);
      });
    handleClose();
  };

  const handleBackStep = () => {
    setStep(step - 1);
    setDestData([
      { id: "horizontal", left: t("COORDINATE_SYSTEM"), right: "" },
      { id: "vertical", left: t("VERTICAL_COORDINATE_SYSTEM"), right: "" },
    ]);
    setLocalizedDestData([
      { id: "rotation", left: t("ROTATION"), right: "" },
      { id: "originEasting", left: t("ORIGIN_EASTING"), right: "" },
      { id: "originNorthing", left: t("ORIGIN_NORTHING"), right: "" },
      { id: "originLatitude", left: t("ORIGIN_LATITUDE"), right: "" },
      { id: "originLongitude", left: t("ORIGIN_LONGITUDE"), right: "" },
      { id: "scaleFactor", left: t("SCALE_FACTOR"), right: "" },
      { id: "verticalOffset", left: t("VERTICAL_OFFSET"), right: "" },
      { id: "inclineX", left: t("INCLINE_X"), right: "" },
      { id: "inclineY", left: t("INCLINE_Y"), right: "" },
    ]);
  };

  // ダイアログ閉じる（初期化）
  const handleClose = () => {
    coordProps.close();
    setStep(1);
    setCoordinateRadio(null);
    // coordProps.setShowFlag(false);

    setDestData([
      { id: "horizontal", left: t("COORDINATE_SYSTEM"), right: "" },
      { id: "vertical", left: t("VERTICAL_COORDINATE_SYSTEM"), right: "" },
    ]);

    setSelectedData([
      { id: "horizontal", value: "", label: "" },
      { id: "vertical", value: "", label: "" },
    ]);

    setLocalizedDestData([
      { id: "rotation", left: t("ROTATION"), right: "" },
      { id: "originEasting", left: t("ORIGIN_EASTING"), right: "" },
      { id: "originNorthing", left: t("ORIGIN_NORTHING"), right: "" },
      { id: "originLatitude", left: t("ORIGIN_LATITUDE"), right: "" },
      { id: "originLongitude", left: t("ORIGIN_LONGITUDE"), right: "" },
      { id: "scaleFactor", left: t("SCALE_FACTOR"), right: "" },
      { id: "verticalOffset", left: t("VERTICAL_OFFSET"), right: "" },
      { id: "inclineX", left: t("INCLINE_X"), right: "" },
      { id: "inclineY", left: t("INCLINE_Y"), right: "" },
    ]);
  };

  const getValueSelect = (type: string) => {
    const value = selectedDestData?.find((x) => x.id === type)?.value;
    return (
      (type === "horizontal" ? coordinateSystemData : verticalShift).find(
        (x) => x.value === value
      ) || null
    );
  };

  // ラジオボタンの切り替え
  const handlerChangeCoordinateSystem = (coordinateVal: number) => {
    setCoordinateRadio(coordinateVal);
  };

  const handlerSetCoordinateSystem = async () => {
    if (coordinateRadio === 1) {
      selectedDestData.forEach((x) => {
        if (x.value) {
          const data = (
            x.id === "horizontal" ? coordinateSystemData : verticalShift
          ).find((item) => item.value === x.value);
          if (data) {
            const newLocalizeData = destData.map((item) => {
              if (item.id === x.id) item.right = data.label;
              return item;
            });
            setDestData(newLocalizeData);
          }
        } else {
          transformFlags = false;
        }
      });
    }

    if (coordinateRadio === 0) {
      let newLocalizeData = undefined;
      let getLocal: any = undefined;

      // if (!dashboardData) {
      //   await fetchDashboardCS(projectDetail?.id);
      // }

      getLocal = dashboardData;

      if (getLocal && !getLocal.conditionFlag) {
        newLocalizeData = destData.map((item) => {
          item.right = (
            item.id === "horizontal" ? coordinateSystemData : verticalShift
          ).find((x) => x.value === getLocal[item.id])?.label;
          return item;
        });
        setDestData(newLocalizeData);
      } else if (getLocal && getLocal.conditionFlag) {
        newLocalizeData = LocalizedDestData.map((item) => {
          item.right = getLocal[item.id as keyof Common.ProjectViDoc];
          return item;
        });
        setLocalizedDestData(newLocalizeData);
      } else {
        transformFlags = false;
      }
    }

    if (coordinateRadio === null) {
      openError(t("PLS_CHOOSE_ONE"));
      transformFlags = false;
      return;
    }

    if (transformFlags) return;

    openError(t("PLS_INPUT_COORD"));
    return (transformFlags = false);
  };

  const getContentText = () => {
    if (displayText && currentType === EDataType.NONE) {
      return t("COORD_SYSTEM_NO_INFO");
    }

    if (step === 1) {
      return (
        <RadioGroup
          value={coordinateRadio}
          onChange={(e, val: string) =>
            handlerChangeCoordinateSystem(Number(val))
          }
        >
          <FormControlLabel
            value="0"
            control={<Radio />}
            label={t("LINK_COORD_SMART_DASHBOARD")}
            className="overflow18"
          />
          <FormControlLabel
            value="1"
            control={<Radio />}
            label={t("CHOOSE_COORD_SYSTEM")}
            className="overflow19"
          />
          <div className="coordinate-select">
            <FormLabel>{t("COORDINATE_SYSTEM")}</FormLabel>
            <Autocomplete
              autoHighlight={true}
              value={getValueSelect("horizontal")}
              disabled={coordinateRadio !== 1}
              size="small"
              options={coordinateSystemData}
              onChange={(event, data) => {
                const newLocalizeSelect = selectedDestData.map((item) => {
                  if (item.id === "horizontal") {
                    item = { ...item, ...data };
                  }
                  return item;
                });
                setSelectedData(newLocalizeSelect);
              }}
              renderInput={(params) => (
                <TextField {...params} value="" placeholder={t("PLS_SELECT")} />
              )}
            />
            <FormLabel>{t("VERTICAL_COORDINATE_SYSTEM")}</FormLabel>
            <Autocomplete
              autoHighlight={true}
              value={getValueSelect("vertical")}
              disabled={coordinateRadio !== 1}
              size="small"
              options={verticalShift}
              onChange={(event, data) => {
                const newLocalizeSelect = selectedDestData.map((item) => {
                  if (item.id === "vertical") {
                    item = { ...item, ...data };
                  }
                  return item;
                });
                setSelectedData(newLocalizeSelect);
              }}
              renderInput={(params) => (
                <TextField {...params} value="" placeholder={t("PLS_SELECT")} />
              )}
            />
          </div>
        </RadioGroup>
      );
    } else {
      return (
        <>
          <div className="content-text-table">
            {step === 2 && <div>{t("ORIGINAL")}</div>}
            <table>
              <tbody>
                {currentType === EDataType.LOCALIZE
                  ? localizedStorageData.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td
                            className={step === 0 ? "td-left-first" : "td-left"}
                          >
                            <FormLabel>{item.left}</FormLabel>
                          </td>
                          <td className="td-right">
                            {Number(
                              FormatUtil.removeDecimalPoint(
                                Number(item.right),
                                5
                              )
                            )}
                          </td>
                        </tr>
                      );
                    })
                  : storageData.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td
                            className={step === 0 ? "td-left-first" : "td-left"}
                          >
                            <FormLabel>{item.left}</FormLabel>
                          </td>
                          <td className="td-right">{item.right}</td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
          {step === 2 ? (
            // EPSG表示
            <div className="content-text-table">
              <div>{t("AFTER_CONVERSION")}</div>
              <table>
                <tbody>
                  {coordinateRadio !== 0 || !dashboardData?.conditionFlag
                    ? destData.map((item) => {
                        return (
                          <tr key={item.id}>
                            <td className="td-left">
                              <FormLabel>{item.left}</FormLabel>
                            </td>
                            <td className="td-right">{item.right}</td>
                          </tr>
                        );
                      })
                    : // ステレオパラメータ表示
                      LocalizedDestData.map((item) => {
                        return (
                          <tr key={item.id}>
                            <td className="td-left">
                              <FormLabel>{item.left}</FormLabel>
                            </td>
                            <td className="td-right">
                              {Number(
                                FormatUtil.removeDecimalPoint(
                                  Number(item.right),
                                  5
                                )
                              )}
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
          ) : (
            <></>
          )}
        </>
      );
    }
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const customModalColor = {
    color: theme.palette.base.modal,
  };

  const customButtonColor = {
    background: theme.palette.primary.main,
    boxShadow: "none",
  };

  const CustomBackButton = styled(Button)({
    background: theme.palette.base.modal,
    color: theme.palette.base.contrast,
    boxShadow: "none",
    "&:hover": {
      background: theme.palette.base.modal,
      color: theme.palette.base.contrast,
      boxShadow: "none",
    },
  });

  return (
    <div className="overflow8">
      <Dialog
        open={coordProps.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: "coordinate-dialog",
          style: { background: customModalColor.color },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: customDialogBackgroundColor.color,
            },
          },
        }}
      >
        <DialogTitle className="title-name" id="alert-dialog-title">
          {t("COORDINATE_SYSTEM_CHANGE")}
          <Button
            style={customColor}
            className="x-btn btn-remove"
            onClick={handleClose}
          >
            ×
          </Button>
          <div className="border-comm" />
        </DialogTitle>
        <DialogContent className="dialog-content-coordinate">
          {getContentText()}
        </DialogContent>
        <DialogActions>
          {step === 2 && (
            <CustomBackButton
              size="small"
              variant="contained"
              onClick={() => handleBackStep()}
              className="dialog-footer-left"
            >
              {t("RETURN")}
            </CustomBackButton>
          )}
          {step === 1 && (
            <LoadingButton
              style={disabledNext1 ? {} : customButtonColor}
              size="small"
              variant="contained"
              onClick={() => handleNextStep()}
              className="loading-white dialog-footer-right"
              disabled={disabledNext1}
              loading={loadingNext1}
            >
              {t("NEXT")}
            </LoadingButton>
          )}
          {step === 2 && (
            <LoadingButton
              style={customButtonColor}
              size="small"
              variant="contained"
              onClick={() => handleNextStep()}
              className="loading-white dialog-footer-right"
              disabled={disableNextStep}
              loading={whileTransform}
            >
              {t("EXECUTION")}
            </LoadingButton>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CoordinateSystemDialog;
